<template>

  <v-container>

    <v-row>
      <v-col
        cols="12"
        sm="6"
        md="6"
      >
        <div class="mr-4">
          <v-row>
            <v-col
                cols="12"
                sm="12"
                md="12"
            >
              <div class="subtitle-1 font-weight-bold">Nama Kegiatan</div>
              <v-divider></v-divider>
              <div class="subtitle-2">{{itemModified.description}}</div>
              <div class="caption ml-8 mt-2">{{itemModified.subKegiatan}}</div>
            </v-col>
          </v-row>
          <v-row>
            <v-col
                cols="12"
                sm="12"
                md="12"
            >
              <div class="subtitle-1 font-weight-bold">Nama Pekerjaan</div>
              <v-divider></v-divider>
              <div class="subtitle-2">{{itemModified.namaPekerjaan}}</div>

            </v-col>
          </v-row>
          <v-row>
            <v-col
                cols="12"
                sm="12"
                md="12"
            >
              <div class="subtitle-1 font-weight-bold">Pagu-Kontrak</div>
              <v-divider></v-divider>
              <div>
                Pagu Rp.
                <span class="subtitle-1">{{formattedCurrencyValue('', itemModified.nilaiPagu)}}</span>
              </div>
              <div>
                Kontrak Rp.
                <span class="subtitle-1 font-weight-bold">{{formattedCurrencyValue('', itemModified.nilaiKontrak)}}</span>
              </div>
            </v-col>
          </v-row>

          <v-row>
            <v-col
                cols="12"
                sm="12"
                md="12"
            >
              <div class="subtitle-1 font-weight-bold">Kontraktor: CV/PT</div>
              <v-divider></v-divider>
              <div>
                <span class="subtitle-1">{{lookupFCvpt(itemModified.cvptBean).description}}</span>
              </div>
              <div>
                <div>{{lookupFCvpt(itemModified.cvptBean).address}}</div>
                <div>{{lookupFCvpt(itemModified.cvptBean).city}}</div>
              </div>
            </v-col>
          </v-row>

        </div>

      </v-col>

      <v-divider vertical></v-divider>

      <v-col
          cols="12"
          sm="6"
          md="6"
      >
        <div class="ml-4">
          <v-row>
            <v-col
                cols="12"
                sm="6"
                md="6"
            >
              <div class="subtitle-1 font-weight-bold">Pejabat Terkait</div>
              <v-divider></v-divider>
              <v-list>
                  <v-list-item>
                    <v-list-item-avatar color="grey lighten-4" size="50">
                      <v-img :lazy-src="lookupImagePegawaiUrlLazy" :src="lookupImagePegawaiUrl(itemModified.kpaBean)"></v-img>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title v-html="lookupFPegawai(itemModified.kpaBean)"></v-list-item-title>
                      <v-list-item-subtitle :class="itemModified.kpaBean?'blue--text': 'grey--text'">KPA</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                <v-list-item>
                  <v-list-item-avatar color="grey lighten-4" size="50">
                    <v-img :lazy-src="lookupImagePegawaiUrlLazy" :src="lookupImagePegawaiUrl(itemModified.pptkBean)"></v-img>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title v-html="lookupFPegawai(itemModified.pptkBean)"></v-list-item-title>
                    <v-list-item-subtitle :class="itemModified.pptkBean?'blue--text': 'grey--text'">PPTK</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-avatar color="grey lighten-4" size="50">
                    <v-img :lazy-src="lookupImagePegawaiUrlLazy" :src="lookupImagePegawaiUrl(itemModified.pengawasBean)"></v-img>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title v-html="lookupFPegawai(itemModified.pengawasBean)" ></v-list-item-title>
                    <v-list-item-subtitle :class="itemModified.pengawasBean?'blue--text': 'grey--text'">PENGAWAS</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

              </v-list>

            </v-col>

          </v-row>

          <v-row>
            <v-col
                cols="12"
                sm="12"
                md="12"
            >
              <div class="subtitle-1 font-weight-bold">PHO-FHO-Kemajuan Fisik-Penyerahan</div>
              <v-divider></v-divider>
              <v-list>
                <v-list-item>
                  <v-list-item-avatar color="grey lighten-4" size="50">
                    <v-img :lazy-src="lookupImagePegawaiUrlLazy" :src="lookupImagePegawaiUrl(itemModified.ketuaBean)"></v-img>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title v-html="lookupFPegawai(itemModified.ketuaBean)"></v-list-item-title>
                    <v-list-item-subtitle :class="itemModified.ketuaBean?'blue--text': 'grey--text'">Ketua</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-avatar color="grey lighten-4" size="50">
                    <v-img :lazy-src="lookupImagePegawaiUrlLazy" :src="lookupImagePegawaiUrl(itemModified.sekretarisBean)"></v-img>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title v-html="lookupFPegawai(itemModified.sekretarisBean)"></v-list-item-title>
                    <v-list-item-subtitle :class="itemModified.sekretarisBean?'blue--text': 'grey--text'">Sekretaris</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-avatar color="grey lighten-4" size="50">
                    <v-img :lazy-src="lookupImagePegawaiUrlLazy" :src="lookupImagePegawaiUrl(itemModified.anggota1Bean)"></v-img>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title v-html="lookupFPegawai(itemModified.anggota1Bean)"></v-list-item-title>
                    <v-list-item-subtitle :class="itemModified.anggota1Bean?'blue--text': 'grey--text'">Anggota-1</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-avatar color="grey lighten-4" size="50">
                    <v-img :lazy-src="lookupImagePegawaiUrlLazy" :src="lookupImagePegawaiUrl(itemModified.anggota2Bean)" ></v-img>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title :v-html="lookupFPegawai(itemModified.anggota2Bean)"></v-list-item-title>
                    <v-list-item-subtitle :class="itemModified.anggota2Bean?'blue--text': 'grey--text'">Anggota-2</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col>

          </v-row>


        </div>
      </v-col>

    </v-row>


  </v-container>

</template>

<script>
import {format, parseISO} from "date-fns";
import FKegiatan from "@/models/f-kegiatan";
import FileService from "@/services/apiservices/file-service";

export default {
  name: "FPengawasanPhoItem",
  props:{
    itemModified: new FKegiatan(),
    itemsFDivision: [],
    itemsFPegawai:[],
    itemsFCvpt: [],

  },
  data() {
    return{
      date: format(parseISO(new Date().toISOString()), 'dd-MMM-yyyy'),
      menuDate1: false,


      selectedItemIndex: -1,
      itemDefault: '',
      // itemModified: new FKegiatan(0, '', ''),
      selectFDivision: {id: 0, kode1: '', description: '' },
      // itemsFDivision: [
      //   new FDivision()
      // ],

      valid: false,
      rulesLenght: [
        v => !!v || ' Tidak Boleh Kosong',
        v => v.length <= 255 || 'Maksimal 255 Karakter',
        v => v.length > 1 || 'Harus lebih besar dari 1 karakter'
      ],
      rulesNotEmtpy: [
        v => !!v || 'Tidak boleh kosong'
      ],

    }
  },
  methods: {
    formatDate (date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${month}/${day}/${year}`
    },
    computedDateFormattedDatefns (value) {
      return value ? format(parseISO(value), 'dd-MMM-yyyy') : ''
    },

    formattedCurrencyValue(prefix, value){
      if(! value){ return "0"}
      // return "Rp." + parseFloat(value).toFixed(0).toLocaleString()
      return prefix + "" + parseFloat(value).toLocaleString()
    },
    lookupFDivision (fdivisionBean) {
      const str = this.itemsFDivision.filter(x => x.id==fdivisionBean)
      if (str.length>0){
        return str[0].description
      }else {
        return '-'
      }
    },
    lookupFPegawai (fpegawaiBean) {
      const str = this.itemsFPegawai.filter(x => x.id==fpegawaiBean)
      if (str.length>0){
        return str[0].description
      }else {
        return '-'
      }
    },
    lookupFCvpt (fcvptBean) {
      const str = this.itemsFCvpt.filter(x => x.id==fcvptBean)
      if (str.length>0){
        return str[0]
      }else {
        return '-'
      }
    },

    lookupImagePegawaiUrl(fpegawaiBean){
      // console.log(this.itemsFPegawai.length)
      // const str = this.itemsFPegawai.filter(x => x.id==fpegawaiBean)
      //Gak tahu kok gak bis
      var str = ''
      for ( let i=0; i<this.itemsFPegawai.length; i++){
        if (this.itemsFPegawai[i].id===fpegawaiBean) {
          str = this.itemsFPegawai[i]
          break;
        }
      }

      if (str.avatarImage===undefined || str.avatarImage===""){
        return '../assets/images/account_icon.png'
      }else {
        return FileService.image_url_medium(str.avatarImage)
      }
    },
    lookupImagePegawaiUrlLazy(){
      return '@/assets/images/account_icon.png'
    },

  }



}

</script>


<style scoped>

</style>